import { Link as RouterLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { forwardRef } from "react";

interface LinkProps extends React.ComponentPropsWithoutRef<typeof RouterLink> {
  className?: string;
}

/**
 * A custom Link component that wraps React Router's Link component.
 * This Link ensures consistent styling and behavior across the application.
 * It automatically scrolls to the top when navigating to a new page.
 */
const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ className, ...props }, ref) => {
  return (
    <RouterLink
      ref={ref}
      className={cn("text-primary hover:text-primary/80 transition-colors", className)}
      {...props}
    />
  );
});

Link.displayName = "Link";

export { Link, useLocation };
